import { useEffect, useState } from "react";

import styled from "styled-components";

import FnrSlides from "UI/FnrSlides";
import FnrTypography from "UI/FnrTypography";

import { hoverTextKeys, useHoverTextKey } from "./toolbarStore";

const hoverKeyToText = {
  [hoverTextKeys.email]: "Send an Email",
  [hoverTextKeys.text]: "Send a Text Message",
  [hoverTextKeys.addMember]: "Add a New Member",
  [hoverTextKeys.superSearch]: "SuperSearch",
};

const hoverTextConfig = [
  {
    key: "show",
    value: ({ text, ...props }) => (
      <CenteringDiv>
        <FnrTypography {...props}>{text}</FnrTypography>
      </CenteringDiv>
    ),
  },
  { key: "hide", value: () => null },
];

const CenteringDiv = styled.div`
  display: flex;
  justify-content: center;
  transform: scale(0.75);
`;

const HoverText = () => {
  const [hoverTextKey] = useHoverTextKey();

  const [text, setText] = useState("");

  useEffect(() => {
    if (hoverTextKey !== hoverTextKeys.noHover)
      setText(hoverKeyToText[hoverTextKey]);
  }, [hoverTextKey]);

  return (
    <SetHeight>
      <FnrSlides
        activeKey={hoverTextKey === hoverTextKeys.noHover ? "hide" : "show"}
        text={text}
        components={hoverTextConfig}
        axis="y"
        color="textLight"
        size="xs"
        noWrap
        clip={false}
        fullWidth
        variant="subtle"
        contentSpring
      />
    </SetHeight>
  );
};

const SetHeight = styled.div`
  height: 16px;
  width: 100%;
  opacity: 0.65;
`;

export default HoverText;
